import { MessagesModel } from "./Messages.model";

export class RequestStatusProcess
{
  IdRequest : number;
  IdTypeRequestStatus: number;
  IdConectionTypeFlow:number;
  Approve?: boolean;
  Rewiewdocument?: boolean;
  Messages:MessagesModel[]
}
